import React, { useState, useEffect } from 'react';
import { useOrderContext } from '../context/OrderContext';
import { useRestaurantContext } from '../context/RestaurantContext';
import { updateOrderStatus } from '../services/api/firebaseAdapter.jsx';
import Icon from './AppIcon';

const DevTools = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { orders } = useOrderContext();
  const { restaurantId } = useRestaurantContext();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.altKey && e.key === 'd') {
        setIsOpen(!isOpen);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleStatusChange = async (orderId, newStatus) => {
    await updateOrderStatus(orderId, newStatus, restaurantId);
  };

  return (
    <div className="fixed bottom-0 right-0 bg-white shadow-lg p-4 border rounded-lg m-4 z-[9999]">
      <h3 className="text-lg font-bold mb-2">Dev Tools</h3>
      <div className="flex flex-col space-y-2">
        <h4 className="font-bold">Orders</h4>
        {orders.map(order => (
          <div key={order.id} className="border p-2 rounded">
            <p className="font-mono text-sm">{order.id}</p>
            <p>Status: {order.orderStatus}</p>
            <div className="flex space-x-2 mt-2">
              <button onClick={() => handleStatusChange(order.id, 'pending')} className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-1 px-2 rounded text-xs">Pending</button>
              <button onClick={() => handleStatusChange(order.id, 'processing')} className="bg-blue-300 hover:bg-blue-400 text-blue-800 font-bold py-1 px-2 rounded text-xs">Processing</button>
              <button onClick={() => handleStatusChange(order.id, 'ready_for_pickup')} className="bg-green-300 hover:bg-green-400 text-green-800 font-bold py-1 px-2 rounded text-xs">Ready</button>
              <button onClick={() => handleStatusChange(order.id, 'completed')} className="bg-purple-300 hover:bg-purple-400 text-purple-800 font-bold py-1 px-2 rounded text-xs">Completed</button>
            </div>
          </div>
        ))}
      </div>
      <button onClick={() => setIsOpen(false)} className="absolute top-2 right-2">
        <Icon name="X" size={18} />
      </button>
    </div>
  );
};

export default DevTools;